module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/paper-stamp-dca62cff07f2667f79b1eff892011846.png";